
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ArrowLeft',
    props: {
        fill: {
            type: String,
            default: null as string | null,
        },
    },
})
